import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    commitAutomatch,
    previewAutomatch,
} from '../../../../services/epcStandardScheduleService';
import type { AutomatchCommitBody } from '../types';

/** preview is a POST (score imported tasks → matched/unmatched). Mutation so callers hold the result. */
export function usePreviewAutomatch(projectId: string) {
    return useMutation({
        mutationFn: (body: { importId?: string }) => previewAutomatch(projectId, body),
    });
}

/** commit — carries automatchId + per-row acceptance. Invalidates day-plan/project/runs. */
export function useCommitAutomatch(projectId: string) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (body: AutomatchCommitBody) => commitAutomatch(projectId, body),
        onSuccess: () => {
            // new mappings + baseline day plans + the apply-runs list all change
            qc.invalidateQueries({ queryKey: ['epc-dm', 'day-plan', projectId] });
            qc.invalidateQueries({ queryKey: ['epc-project', projectId] });
            qc.invalidateQueries({ queryKey: ['epc', 'standard-apply-runs', projectId] });
        },
    });
}
